export const GET_EXCO_KABKOT = "GET_EXCO_KABKOT";
export const GET_EXCO_KABKOT_SUCCESS = "GET_EXCO_KABKOT_SUCCESS";
export const GET_EXCO_KABKOT_FAIL = "GET_EXCO_KABKOT_FAIL";
